(function () {
    function waitForFlickityInstance(carousel, callback, onTimeout) {
        let attempts = 0;
        const interval = setInterval(function () {
            attempts++;
            const flkty = typeof Flickity !== 'undefined' ? Flickity.data(carousel) : null;

            if (flkty) {
                clearInterval(interval);
                callback(flkty);
            } else if (attempts > 100) {
                clearInterval(interval);
                if (onTimeout) onTimeout();
            }
        }, 50);
    }

    function countCells(carouselEl) {
        const slider = carouselEl.querySelector('.flickity-slider');
        return (slider || carouselEl).children.length;
    }

    function setCounters(controlsEl, current, total) {
        controlsEl.querySelectorAll('.js-tabs-counter-total').forEach(el => (el.textContent = total));
        controlsEl.querySelectorAll('.js-tabs-counter-current').forEach(el => (el.textContent = current));
    }

    function findCarousel(controlsEl) {
        let node = controlsEl.parentElement;

        while (node) {
            const active = node.querySelector('.section-tabs__panel.is-active .js-carousel');
            if (active) return active;

            const carousel = node.querySelector('.js-carousel');
            if (carousel) return carousel;

            node = node.parentElement;
        }

        return null;
    }

    function getFlickity(controlsEl) {
        const carouselEl = findCarousel(controlsEl);
        if (!carouselEl) return null;
        return typeof Flickity !== 'undefined' ? Flickity.data(carouselEl) : null;
    }

    function updateCounters(controlsEl, flkty) {
        const total =
            (flkty.slides && flkty.slides.length) ||
            (flkty.cells && flkty.cells.length) ||
            countCells(flkty.element);

        setCounters(controlsEl, flkty.selectedIndex + 1, total);
    }

    function refresh(controlsEl) {
        const carouselEl = findCarousel(controlsEl);
        if (!carouselEl) return;

        waitForFlickityInstance(
            carouselEl,
            function (flkty) {
                flkty.resize();
                updateCounters(controlsEl, flkty);

                if (controlsEl.carouselControlsTarget === carouselEl) return;
                controlsEl.carouselControlsTarget = carouselEl;

                ['ready', 'resize', 'select', 'change', 'settle'].forEach(function (eventName) {
                    flkty.on(eventName, function () {
                        updateCounters(controlsEl, flkty);
                    });
                });
            },
            function () {
                const total = countCells(carouselEl);
                setCounters(controlsEl, total > 0 ? 1 : 0, total);
            }
        );
    }

    function initControls(controlsEl) {
        if (controlsEl.dataset.controlsInitialized !== 'true') {
            controlsEl.dataset.controlsInitialized = 'true';

            const prevBtns = controlsEl.querySelectorAll('.collection__controls__arrow--prev, .tabs__arrow--prev');
            const nextBtns = controlsEl.querySelectorAll('.collection__controls__arrow--next, .tabs__arrow--next');

            prevBtns.forEach(btn => {
                btn.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    const flkty = getFlickity(controlsEl);
                    if (flkty) {
                        flkty.previous();
                        updateCounters(controlsEl, flkty);
                    }
                });
            });

            nextBtns.forEach(btn => {
                btn.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    const flkty = getFlickity(controlsEl);
                    if (flkty) {
                        flkty.next();
                        updateCounters(controlsEl, flkty);
                    }
                });
            });
        }

        refresh(controlsEl);
    }

    function initScope(scopeEl) {
        if (!scopeEl) return;

        scopeEl.querySelectorAll('.collection__controls').forEach(initControls);

        scopeEl.querySelectorAll('.section-tabs__btn').forEach(tabBtn => {
            if (tabBtn.dataset.controlsTabBound === 'true') return;
            tabBtn.dataset.controlsTabBound = 'true';

            tabBtn.addEventListener('click', function () {
                setTimeout(function () {
                    scopeEl.querySelectorAll('.collection__controls').forEach(refresh);
                }, 100);
            });
        });
    }

    function setupAllInstances() {
        initScope(document);
    }

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        setupAllInstances();
    } else {
        document.addEventListener('DOMContentLoaded', setupAllInstances);
    }

    document.addEventListener('shopify:section:load', function (e) {
        if (e.target) {
            e.target.querySelectorAll('.collection__controls').forEach(el => {
                el.removeAttribute('data-controls-initialized');
                el.carouselControlsTarget = null;
            });
            initScope(e.target);
        }
    });
})();
